<template>
  <div :class="{ headerbg: (headerIndex == 0 || headerIndex == 3) && !iswrite }">
    <button class="release" @click="goRelease">
      <img
        :src="
          (headerIndex == 0 || headerIndex == 3) && !iswrite
            ? '/static/images/community/new-img/release.png?v=1'
            : '/static/images/community/release.png?v=1'
        "
      />
    </button>
    <ul>
      <li
        :class="{
          navColor: headerIndex == index,
          navColor0: (headerIndex == 0 || headerIndex == 3) && !iswrite
        }"
        v-for="(item, index) of nav"
        @click="headerClick(index)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
import { isWeixin } from '../../assets/common/js/config'
export default {
  name: 'communityHeader',
  data() {
    return {
      nav: ['主页', '热门', '关注', '函金靓'],
      iswrite: false
    }
  },
  props: {
    headerIndex: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    // this.scroll()
    // // 挂载完成后，判断浏览器是否支持popstate
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    setTimeout(() => {
      if (document.getElementsByClassName('headerInfo').length) {
        window.removeEventListener('scroll', this.scroll, false)
        window.addEventListener('scroll', this.scroll, false)
      }
    }, 500)
  },
  watch: {
    headerIndex: function(val, oldVal) {
      console.log('headerIndex', val)
      setTimeout(() => {
        if (document.getElementsByClassName('headerInfo').length) {
          window.removeEventListener('scroll', this.scroll, false)
          window.addEventListener('scroll', this.scroll, false)
        }
      }, 500)
    }
  },
  destroyed() {
    // window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    scroll: function() {
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let boxheight = document.getElementsByClassName('headerInfo')[0].clientHeight
      if (scrollTop > boxheight - 50) {
        this.iswrite = true
      } else {
        this.iswrite = false
      }
    },

    goRelease: function() {
      var that = this
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'community'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f() {
        that.$clickburiedPoint({
          data: {
            buttonCode: 'posted'
          },
          url: 'community/userbehavior/save'
        })
        that.$router.push({
          path: '/communityevaluation'
        })
      }
    },
    headerClick: function(idx) {
      window.scrollTo(0, 0)
      this.$store.commit('COMMUNITY_TAB', idx)
      this.$emit('headerClick', idx)
    }
  }
}
</script>

<style scoped lang="scss">
div {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 0.46rem;
  background: #ffffff;
  padding: 0 0.11rem;
  transition: all 0.2s;
  &.headerbg {
    background: transparent;
  }
  button {
    &.release img {
      width: 0.2rem;
      height: 0.32rem;
    }
    &.search img {
      width: 0.18rem;
      height: 0.18rem;
    }
    font-size: 0.17rem;
    color: #222222;
    border-width: 0;
    outline: none;
    background: transparent;
    /*padding: 0 0.11rem;*/
  }
  ul {
    font-size: 0;
    flex: 1;
    text-align: center;
    li {
      display: inline-block;
      font-size: 0.17rem;
      color: #222222;
      margin-right: 0.28rem;
      transition: all 0.2s;
      &:first-of-type {
        margin-left: -0.2rem;
      }
      &:last-of-type {
        margin-right: 0;
      }
      &.navColor0 {
        color: #ffffff;
      }
      &.navColor {
        color: #fe0f41;
        font-weight: 600;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          display: block;
          width: 0.26rem;
          height: 0.03rem;
          background: linear-gradient(90deg, #fc0324 0%, #fc0324 100%);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/communityHeader.vue